/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInnerPlan } from './get-trustdock-verifications200-response-company-verification-document-records-inner-plan';
// May contain unused imports in some cases
// @ts-ignore
import { GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInnerReasonsInner } from './get-trustdock-verifications200-response-company-verification-document-records-inner-reasons-inner';
// May contain unused imports in some cases
// @ts-ignore
import { GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInnerResult } from './get-trustdock-verifications200-response-company-verification-document-records-inner-result';

/**
 * 
 * @export
 * @interface GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInner
 */
export interface GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInner {
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInner
     */
    'state': GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInnerStateEnum;
    /**
     * 
     * @type {GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInnerResult}
     * @memberof GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInner
     */
    'result': GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInnerResult | null;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInner
     */
    'verifiedAt': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInner
     */
    'verifiedBy': Array<string> | null;
    /**
     * 
     * @type {GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInnerPlan}
     * @memberof GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInner
     */
    'plan': GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInnerPlan | null;
    /**
     * 
     * @type {object}
     * @memberof GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInner
     */
    'document': object | null;
    /**
     * 
     * @type {Array<GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInnerReasonsInner>}
     * @memberof GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInner
     */
    'reasons': Array<GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInnerReasonsInner> | null;
}

export const GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInnerStateEnum = {
    accepted: 'accepted',
    plansSelected: 'plans_selected',
    documentSubmitted: 'document_submitted',
    inProgress: 'in_progress',
    verified: 'verified'
} as const;

export type GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInnerStateEnum = typeof GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInnerStateEnum[keyof typeof GetTrustdockVerifications200ResponseCompanyVerificationDocumentRecordsInnerStateEnum];


